import React from "react";

import {
  Button,
  Grid,
  MenuItem,
  Paper,
  Stack,
  TextField,
} from "@mui/material";

import ClearRoundedIcon from "@mui/icons-material/ClearRounded";

import { AnalyticsFilterOption, AnalyticsFilters } from "../types";

interface FiltersProps {
  filters: AnalyticsFilters;

  onChange: (
    filters: Partial<AnalyticsFilters>
  ) => void;

  onReset: () => void;

  hubs?: AnalyticsFilterOption[];

  categories?: AnalyticsFilterOption[];

  suppliers?: AnalyticsFilterOption[];
}

const Filters: React.FC<FiltersProps> = ({
  filters,
  onChange,
  onReset,
  hubs = [],
  categories = [],
  suppliers = [],
}) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: { xs: 1.5, md: 2 },
        mb: 1.5,
      }}
    >
      <Grid
        container
        spacing={1.25}
      >
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            type="date"
            label="Start Date"
            InputLabelProps={{
              shrink: true,
            }}
            value={filters.fromDate ?? filters.startDate ?? ""}
            onChange={(e) =>
              onChange({
                fromDate: e.target.value,
                startDate: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            type="date"
            label="End Date"
            InputLabelProps={{
              shrink: true,
            }}
            value={filters.toDate ?? filters.endDate ?? ""}
            onChange={(e) =>
              onChange({
                toDate: e.target.value,
                endDate: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="Warehouse"
            value={filters.warehouseId ?? ""}
            onChange={(e) =>
              onChange({
                warehouseId: e.target.value,
              })
            }
          >
            <MenuItem value="">
              All Hubs
            </MenuItem>

            {hubs.map((hub) => (
              <MenuItem key={hub.id} value={hub.id}>
                {hub.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="Category"
            value={filters.categoryId ?? ""}
            onChange={(e) =>
              onChange({
                categoryId: e.target.value,
              })
            }
          >
            <MenuItem value="">
              All Categories
            </MenuItem>

            {categories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="Supplier"
            value={filters.supplierId ?? ""}
            onChange={(e) =>
              onChange({
                supplierId: e.target.value,
              })
            }
          >
            <MenuItem value="">
              All Suppliers
            </MenuItem>

            {suppliers.map((supplier) => (
              <MenuItem key={supplier.id} value={supplier.id}>
                {supplier.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <Stack
            direction="row"
            spacing={1}
            height="100%"
            alignItems="center"
          >
            <Button
              fullWidth
              variant="outlined"
              startIcon={
                <ClearRoundedIcon />
              }
              onClick={onReset}
            >
              Reset
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Filters;
